import './Donate1ReportsCTA.css'
import { Link } from 'react-router-dom'
import { Donate1Newsletter } from './Donate1Newsletter'

export function Donate1ReportsCTA(): JSX.Element {
  return (
    <>
      <div className="Donate1ReportsCTA">
        <h2 className="Donate1ReportsCTA-Headline">
          Ready to take action?
        </h2>
        <p className="Donate1ReportsCTA-Subtitle">
          Together, we can secure a future for Nigeria's pangolins!
        </p>
        <p className="Donate1ReportsCTA-Subtext">
          Your generosity supports education, scientific discovery, community stewardship, and the next generation of conservation leaders in Nigeria.
        </p>
        <button type="button" className="Donate1ReportsCTA-Button Donate1ReportsCTA-Button-Placeholder" disabled>
          Coming Soon
        </button>
      </div>
      <div className="Donate1Reports">
        <Donate1Newsletter />
        <div className="Donate1ReportsCTA-ReportsBox">
          <p>Want the full picture of our impact? Explore our strategy and annual reports.</p>
          <Link to="/about#reports" className="Donate1ReportsCTA-ReportsLink">
            See our reports
          </Link>
        </div>
      </div>
    </>
  )
}
